// import axios from 'axios';
// // const baseUrl = ' '
// const baseUrl = 'https://micropush.ebopencloud.com' //这里的baseurl可以根据下环境来判断变化， 域名 ip地址 端口号 

// const service = axios.create({
//         baseURL: baseUrl, // api的base_url
//         timeout: 7000, // 请求超时时间
//         headers: {
//             'Content-Type': 'application/json;charset=UTF-8'
//         }
//     })
//     // 请求拦截
// service.interceptors.request.use(config => {
//     return config
// }, error => {
//     console.log(error);
//     return Promise.reject(error)
// })

// // 响应拦截
// service.interceptors.response.use(
//     response => {
//         console.log("响应拦截");

//         // if (response.state.stateCode == 1) {
//         //     this.$weui.alert('响应失败', {
//         //         title: '系统提示',
//         //         buttons: [{
//         //             label: '确定',
//         //             type: 'primary',
//         //             onClick: function() {
//         //                 this.$router.replace('/index');
//         //             }
//         //         }]
//         //     });

//         // }
//         return response;
//     },
//     error => {
//         let originalRequest = error.config
//             // if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1 && !originalRequest._retry) {
//             //     // MessageBox('提示', '请求超时');
//             //     return;
//             // }
//         console.log(error.config);

//         if (error.response) {
//             // switch (error.response.status) {
//             //     case 403:
//             //         this.$router.replace('/wechat/user/user');
//             //         break;
//             // }
//             // 这里可以判断一下回来的错误状态码  ，然后进行统一处理跳转，和后端商量好状态码
//             console.log(error.response);

//         }
//         return Promise.reject(error)
//     }
// )

// export default service



import api1 from './apis/test'

export default {
    api1,

}



// WEBPACK FOOTER //
// ./src/request/apis.js